import React, { useRef, useEffect, useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { ICON_SAVE, ICON_CANCEL } from '../../extras/icons';
//Redux
import { useDispatch, useSelector } from 'react-redux';
import { saveFunctionariesAction, updateFunctionariesAction } from '../../../actions/functionariesActions';
import { listUnitsAction } from '../../../actions/unitsActions';
import { listFunctionaryTypesAction } from '../../../actions/functionaryTypesActions';
import { Formik } from 'formik';
import ButtonSpinner from '../../layout/ButtonSpinner';
import * as yup from 'yup';
import { setLocale } from 'yup';
// import functionaryTypes from '../../../data/functionaryTypes';
//Función principal
const FunctionaryForm = props => {
    //Tomo los props
    const { show, handleClose } = props;
    //Genero los refs
    const refApellido = useRef();
    //Datos iniciales
    const initialData = {
        apellido: '',
        nombre: '',
        tipo: '',
        legajo: '',
        email: '',
        telefono: '',
        unidad: ''
    }
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Traigo el store de persona tipos
    const functionariesLoading = useSelector( state => state.functionaries.loadingSave );
    const errorSave = useSelector( state => state.functionaries.errorSave );
    const isEdit = useSelector( state => state.functionaries.isEdit );
    const functionarySelected = useSelector( state => state.functionaries.functionarySelected );
    const units = useSelector( state => state.units.units );
    const functionaryTypes = useSelector( state => state.functionaryTypes.functionaryTypes );
    //Inicializo el state local
    const [ functionary, setFunctionary ] = useState(initialData);
    //Modifico según el cambio
    useEffect(() => {
        //Me fijo si es edición
        if(isEdit && functionarySelected){
            setFunctionary({
                ...functionarySelected,
                tipo: functionarySelected.tipo.id,
                unidad: functionarySelected.unidad.id
            });
        }else{
            setFunctionary(initialData);
        }
    }, [isEdit, functionarySelected, show])
    //Manejo de cambios
    const handleChange = e => {
        setFunctionary({
            ...functionary,
            [e.target.name]: e.target.value
        })
    }
    //Manejo el guardado
    const handleSave = values => {
        //Armo el objeto de datos
        let data = {
            apellido: values.apellido,
            nombre: values.nombre,
            email: values.email,
            legajo: values.legajo,
            telefono: values.telefono,
            tipo: {
                id: values.tipo
            },
            unidad: {
                id: values.unidad
            },
            activo: 1
        }
        //Verifico si es edición o alta
        if(functionary.id){
            //Agrego el ID
            data = {
                id: functionary.id,
                ...data
            }
            //Es edición
            dispatch( updateFunctionariesAction(data, handleCloseForm) );
        }else{
            //Es creación
            dispatch( saveFunctionariesAction(data, handleCloseForm) );
        }
    }
    //Manejo cuando se muestra
    const handleOnShow = e => {
        //Me fijo si se cargaron las unidades
        if(!units){
            dispatch( listUnitsAction({
                search: 'activo:1'
            }) );
        }
        //Me fijo si cargaron los tipos
        if(!functionaryTypes){
            dispatch( listFunctionaryTypesAction({
                search: 'activo:1'
            }) );
        }
        //Pongo el foco en el primer campo
        refApellido.current.focus();
    }
    //Manejo cierre de la ventana
    const handleCloseForm = e => {
        //Reinicio datos
        setFunctionary(initialData);
        //Cierro
        handleClose();
    }
    //Esquema de validación
    const validationSchema = yup.object({
        apellido: yup.string().required(),
        nombre: yup.string().required(),
        legajo: yup.number().nullable(),
        email: yup.string().email().required(),
        telefono: yup.string().nullable(),
        tipo: yup.number().required(),
        unidad: yup.number().required()
    });
    //Renderizo
    return (
        <Modal 
            show={show} 
            onHide={handleCloseForm} 
            onShow={handleOnShow} 
            aria-labelledby="contained-modal-title-vcenter" 
            centered
            size="lg"
            >
            <Modal.Header closeButton>
                <Modal.Title>
                    Funcionario&nbsp;
                    <small><strong>{ isEdit ? 'Editar' : 'Nuevo' } Registro</strong></small>
                </Modal.Title>
            </Modal.Header>
            <Formik
                enableReinitialize
                validationSchema={validationSchema}
                initialValues={{ ...functionary }}
                onSubmit={ values => handleSave(values) }
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    touched,
                    isValid,
                    errors,
                    isSubmitting
                }) => (
                    <form noValidate onSubmit={handleSubmit} autoComplete="off">
                        <Modal.Body>
                            <div className="row">
                            <Form.Group className="col-md-6">
                                    <label htmlFor="apellido">Apellido</label>
                                    <Form.Control
                                        id="apellido"
                                        className="form-control" 
                                        autoFocus 
                                        name="apellido" 
                                        type="text" 
                                        value={ values.apellido }
                                        onChange={handleChange}
                                        ref={refApellido}
                                        isInvalid={!!errors.apellido}
                                        disabled={ functionariesLoading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.apellido }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-6">
                                    <label htmlFor="nombre">Nombre</label>
                                    <Form.Control
                                        id="nombre"
                                        className="form-control" 
                                        name="nombre" 
                                        type="text" 
                                        value={ values.nombre }
                                        onChange={handleChange}
                                        isInvalid={!!errors.nombre}
                                        disabled={ functionariesLoading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.nombre }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-3">
                                    <label htmlFor="tipo">Tipo</label>
                                    <Form.Control
                                        as="select"
                                        id="tipo"
                                        className="form-control"  
                                        name="tipo" 
                                        value={ values.tipo }
                                        onChange={handleChange}
                                        isInvalid={!!errors.tipo}
                                        disabled={ functionariesLoading }
                                    >
                                        <option value="">Seleccione el Tipo</option>
                                        {
                                            functionaryTypes && functionaryTypes.map(functionaryType => (
                                                <option value={functionaryType.id} key={`ft${functionaryType.id}`}>
                                                    { functionaryType.descripcion }
                                                </option>
                                            ))
                                        }
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        { errors.tipo }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-3">
                                    <label htmlFor="legajo">Legajo</label>
                                    <Form.Control
                                        id="legajo"
                                        className="form-control" 
                                        name="legajo" 
                                        type="text" 
                                        value={ values.legajo }
                                        onChange={handleChange}
                                        isInvalid={!!errors.legajo}
                                        disabled={ functionariesLoading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.legajo }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-6">
                                    <label htmlFor="email">Email</label>
                                    <Form.Control
                                        id="email"
                                        className="form-control" 
                                        name="email" 
                                        type="text" 
                                        value={ values.email }
                                        onChange={handleChange}
                                        isInvalid={!!errors.email}
                                        disabled={ functionariesLoading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.email }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-3">
                                    <label htmlFor="telefono">Teléfono</label>
                                    <Form.Control
                                        id="telefono"
                                        className="form-control" 
                                        name="telefono" 
                                        type="text" 
                                        value={ values.telefono }
                                        onChange={handleChange}
                                        isInvalid={!!errors.telefono}
                                        disabled={ functionariesLoading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.telefono }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-9">
                                    <label htmlFor="unidad">Unidad Judicial</label>
                                    <Form.Control
                                        as="select"
                                        id="unidad"
                                        className="form-control"  
                                        name="unidad"  
                                        value={ values.unidad }
                                        onChange={handleChange}
                                        isInvalid={!!errors.unidad}
                                        disabled={ functionariesLoading }
                                    >
                                        <option value="">Seleccione la Unidad</option>
                                        {
                                            units ? (
                                                units.map(unit => (
                                                    <option value={unit.id} key={`fu${unit.id}`}>
                                                        { unit.descripcion }
                                                    </option>
                                                ))
                                            ) : null
                                        }
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        { errors.unit }
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            {
                                functionariesLoading ? (
                                    <ButtonSpinner />
                                ) : (
                                    <Button variant="success" type="submit" disabled={ functionariesLoading }>
                                        <ICON_SAVE /> <strong>{ isEdit ? 'ACTUALIZAR' : 'GUARDAR' }</strong>
                                    </Button>
                                )
                            }
                            <Button variant="secondary" onClick={handleCloseForm} disabled={ functionariesLoading }>
                                <ICON_CANCEL /> Cancelar
                            </Button>
                        </Modal.Footer>
                    </form>
                )}
            </Formik>
        </Modal>
    );
};

export default FunctionaryForm;